<template>
  <Page :title="title" back-to="/admin/invoices">
    <template v-slot:actions>
      <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item :to="`/admin/invoices/${id}/edit`">
            <v-list-item-title>
              <v-icon left>mdi-pencil</v-icon>
              Editar
            </v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item>
            <v-list-item-title class="red--text">
              <v-icon color="red" left>mdi-delete</v-icon>
              Excluir
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <v-container style="max-width: 550px">
      <InvoicesForm
        ref="form"
        :clients="clients"
        @submit="updateInvoice"
        @cancel="handleCancel"
      />
    </v-container>
  </Page>
</template>

<script>
import Page from "@/components/layout/Page";
import Service from "@/services/InvoicesService";
import MoneyMixin from "@/mixins/MoneyMixin";
import DateTimeMixin from "@/mixins/DateTimeMixin";
import InvoicesForm from "@/components/forms/InvoicesForm";

const service = new Service();

export default {
  components: { Page, InvoicesForm },

  mixins: [MoneyMixin, DateTimeMixin],

  props: {
    id: [Number, String]
  },

  data() {
    return {
      service,
      clients: []
    };
  },

  methods: {
    handleCancel() {
      this.$router.push(`/admin/invoices/${this.id}`);
    },
    async getData() {
      const response = await this.service.show(this.id, { meta: true });
      this.clients = response.meta.clients;
      this.$refs.form.init({
        ...response.data,
        date: this.getDateString(response.data.date)
      });
    },
    async updateInvoice(form) {
      this.$refs.form.loading = true;
      const response = await this.service.update(form, this.id);
      this.$router.replace(`/admin/invoices/${response.data.invoice_number}`);
      this.$refs.form.loading = false;
    }
  },

  computed: {
    title() {
      return this.invoice ? `Invoice ${this.invoice.invoice_number}` : ``;
    }
  },

  created() {
    this.getData();
  }
};
</script>
